export type TranslationKey =
  | "viewMore"
  | "or"
  | "appTitle"
  | "supportTitle"
  | "campaignsTitle"
  | "reportTitle"
  | "cookieControlTitle"
  | "cultureShift"
  | "homeTitle"
  | "menuLabel"
  | "closeMenuLabel"
  | "skipToContent"
  | "licensedBy"
  | "connectWithUs"
  | "emailUs"
  | "getInTouch"
  | "viewOnMap"
  | "address"
  | "reportCta"
  | "backLabel"
  | "continueLabel"
  | "skipToEndLabel"
  | "sendReportLabel"
  | "thankYouTitle"
  | "reviewAnswers"
  | "questionNotAnswered"
  | "imagesAttached"
  | "change"
  | "otherPleaseSpecify"
  | "whatIs"
  | "filesTooLargeError"
  | "pageIncompleteError"
  | "selectedFileCount"
  | "sendingReport"
  | "doNotCloseTab"
  | "required"
  | "maxCharacters"
  | "charactersLeft"
  | "charactersOver"
  | "maxCharactersShorthand"
  | "maxCharactersError"
  | "errorSummaryTitle"
  | "errorLabelTitle"
  | "textQuestionInvalid"
  | "emailQuestionInvalid"
  | "phoneQuestionInvalid"
  | "imageQuestionInvalid"
  | "radioQuestionInvalid"
  | "checkboxQuestionInvalid"
  | "defaultQuestionInvalid"
  | "notFoundTitle"
  | "pageNotFoundTitle"
  | "pageNotFoundBody";

type TranslationDefinition =
  | TranslationKey
  | `${TranslationKey}_one`
  | `${TranslationKey}_other`
  | `${TranslationKey}_interval`;

const resources: Record<string, { translation: { [key in TranslationDefinition]?: string } }> = {
  "en-GB": {
    translation: {
      // Literal phrases
      viewMore: "View more",
      or: "or",

      // Page titles
      appTitle: "Report + Support",
      supportTitle: "Support",
      campaignsTitle: "Campaigns",
      reportTitle: "Report",
      cookieControlTitle: "Cookie Control",

      // Other things in the header
      cultureShift: "Culture Shift",
      homeTitle: "Home",
      menuLabel: "Menu",
      closeMenuLabel: "Close menu",
      skipToContent: "Skip to content",

      // Footer
      licensedBy: "Licensed by",
      connectWithUs: "Connect With Us",
      emailUs: "Email us",
      getInTouch: "Get in touch",
      viewOnMap: "View on map",
      address: "Address",

      // The reporting CTA
      reportCta_interval:
        "(0)[You can not currently report issues through this website];" +
        "(1)[You can tell us what happened through this website];" +
        "(2)[There are two ways you can tell us what happened];" +
        "(3)[There are three ways you can tell us what happened];" +
        "(4-inf)[There are a few ways you can tell us what happened];",

      // Reporting labels
      backLabel: "Back",
      continueLabel: "Continue",
      skipToEndLabel: "Report now",
      sendReportLabel: "Send report",
      thankYouTitle: "Thank You",
      reviewAnswers: "Review your answers",
      questionNotAnswered: "You did not answer this question",
      imagesAttached_one: "{{count}} image attached",
      imagesAttached_other: "{{count}} images attached",
      change: "Change",
      otherPleaseSpecify: "If other, please specify",
      whatIs: "What is {{value}}?",

      // Validation errors etc
      filesTooLargeError: "The maximum size of attached images can be no more than 6MB.",
      pageIncompleteError: "Please complete the questions before continuing",
      selectedFileCount_one: "({{count}} image previously selected)",
      selectedFileCount_other: "({{count}} images previously selected)",
      sendingReport: "Uploading report...",
      doNotCloseTab: "Please do not close this browser tab.",
      required: "This question is required.",

      maxCharacters: "Maximum {{count}} characters",
      charactersLeft_one: "{{count}} character left",
      charactersLeft_other: "{{count}} characters left",
      charactersOver_one: "{{count}} character over",
      charactersOver_other: "{{count}} characters over",
      maxCharactersShorthand: "{{used}}/{{limit}} characters",
      maxCharactersError: "Please limit your answer to {{count}} characters",

      errorSummaryTitle_one: "There is a problem with the following question",
      errorSummaryTitle_other: "There is a problem with the following questions",

      errorLabelTitle: "Error:",
      textQuestionInvalid: "Please enter an answer",
      emailQuestionInvalid: "Please enter a valid email address",
      phoneQuestionInvalid: "Please enter a valid phone number",
      imageQuestionInvalid: "Please upload any required images",
      radioQuestionInvalid: "Please choose an option from the list",
      checkboxQuestionInvalid: "Please choose one or more options from the list",
      defaultQuestionInvalid: "Please complete this question",

      // 404 page
      notFoundTitle: "Not Found",
      pageNotFoundTitle: "Page not found",
      pageNotFoundBody: "Sorry, there is no content at this location.",
    },
  },
};

export default resources;
